import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

// Função para chamar a IA no backend (Cloud Functions)
export const enviarMensagemElion = async (dados) => {
  try {
    // 1. Pega a instância do App Firebase já inicializado
    const functions = getFunctions(getApp());

    // 2. Define qual função do backend vamos chamar
    // OBS: Certifique-se que no seu backend (functions/index.js) o nome é 'chatElion'
    const chatFunction = httpsCallable(functions, 'chatElion');

    // 3. Envia os dados e espera a resposta
    const response = await chatFunction(dados);

    // 4. Retorna a resposta tratada
    return response.data;
  } catch (error) {
    console.error('Erro ao chamar Elion:', error);
    throw error;
  }
};
